var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbstract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1200px",
    height: "1200px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0AEB6;}\n\t.st1{fill:#39262B;}\n\t.st2{fill:#E8615D;}\n\t.st3{fill:#AFBECE;}\n\t.st4{fill:none;stroke:#000000;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "625.1,158 564.6,218.4 624.9,278.7 686.4,217.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.4,498.2h403c0,0,2.9-209.8-195.4-209.8S420.4,498.2,420.4,498.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.4,
    y: 498.2,
    className: "st2",
    width: 77.9,
    height: 407.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.1,
    y: 498.2,
    className: "st2",
    width: 77.9,
    height: 407.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 575.5,
    cy: 939.4,
    r: 24.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 675.6,
    cy: 939.4,
    r: 24.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "skeleton_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "rightShoulder",
    cx: 518.6,
    cy: 354.1,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightElbow",
    cx: 415.1,
    cy: 354.2,
    r: 8.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "rightWrist",
    transform: "matrix(0.9806 -0.1961 0.1961 0.9806 -65.8307 56.3655)",
    cx: 251.7,
    cy: 360.6,
    rx: 8.2,
    ry: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightHip",
    cx: 568.9,
    cy: 569.9,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightKnee",
    cx: 575.3,
    cy: 730.1,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightAnkle",
    cx: 575.3,
    cy: 938.1,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftShoulder",
    cx: 731.5,
    cy: 354.1,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftElbow",
    cx: 835.9,
    cy: 353.8,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftWrist",
    cx: 999.3,
    cy: 360.1,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftHip",
    cx: 685.3,
    cy: 569.1,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftKnee",
    cx: 685.3,
    cy: 730.1,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftAnkle",
    cx: 685.3,
    cy: 938.1,
    r: 8.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "518.5,354.4 568.8,570.2 685.2,569.4 731.4,354.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "517.5,354.4 414.8,354.4 251.5,360.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "732.9,354 836.1,354 999.4,360.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "568.8,570.2 575.2,730.4 575.2,938.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "685.2,569.4 685.2,730.4 685.2,938.4  "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye0",
    cx: 594.4,
    cy: 220,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow1",
    cx: 592.2,
    cy: 208.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow4",
    cx: 615.5,
    cy: 211.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nose1",
    cx: 623.4,
    cy: 221,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow3",
    cx: 605.7,
    cy: 207.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye1",
    cx: 599.6,
    cy: 216.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow0",
    cx: 588.2,
    cy: 211.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow2",
    cx: 598.4,
    cy: 207.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye5",
    cx: 599.6,
    cy: 222.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye2",
    cx: 605.9,
    cy: 216.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye3",
    cx: 611.1,
    cy: 220.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nose0",
    cx: 623.4,
    cy: 215.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nose3",
    cx: 623.4,
    cy: 233.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightNose0",
    cx: 612.7,
    cy: 238.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightMouthCorner",
    cx: 606.7,
    cy: 260.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightNose1",
    cx: 617.9,
    cy: 238.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightUpperLipTop0",
    cx: 613.6,
    cy: 256.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nose2",
    cx: 623.4,
    cy: 226.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nose4",
    cx: 623.4,
    cy: 238.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "upperLipTopMid",
    cx: 624.2,
    cy: 256.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightUpperLipTop1",
    cx: 620.1,
    cy: 255.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "rightMiddleLip",
    d: "M610.3,259.7c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8c-0.4,0-0.8-0.4-0.8-0.8 C609.5,260.1,609.9,259.7,610.3,259.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lowerLipBottomMid",
    cx: 624.2,
    cy: 269.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "upperLipBottomMid",
    cx: 624.2,
    cy: 260.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "lowerLipTopMid",
    cx: 624.2,
    cy: 263.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightUpperLipBottom1",
    cx: 620.3,
    cy: 259.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightLowerLipTop0",
    cx: 620.3,
    cy: 262.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightLowerLipBottom1",
    cx: 620.1,
    cy: 269.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightLowerLipBottom0",
    cx: 613.1,
    cy: 266.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightEye4",
    cx: 605.9,
    cy: 221.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "jawMid",
    cx: 624.2,
    cy: 295.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw7",
    cx: 609.2,
    cy: 292.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw6",
    cx: 599.2,
    cy: 285.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw5",
    cx: 587.6,
    cy: 273.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw4",
    cx: 580.8,
    cy: 253.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw3",
    cx: 580,
    cy: 231.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw2",
    cx: 580,
    cy: 222,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw1",
    cx: 580.8,
    cy: 210.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw0",
    cx: 583.3,
    cy: 201,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "topMid",
    cx: 624.4,
    cy: 174.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftTop0",
    cx: 644.1,
    cy: 177.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftTop1",
    cx: 656.7,
    cy: 186.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye0",
    cx: 654,
    cy: 220,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow1",
    cx: 655.9,
    cy: 208.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow4",
    cx: 632.3,
    cy: 210.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow3",
    cx: 642.3,
    cy: 207.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye1",
    cx: 648.8,
    cy: 216.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow0",
    cx: 659.9,
    cy: 211.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow2",
    cx: 649.6,
    cy: 207,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye5",
    cx: 648.8,
    cy: 222.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye2",
    cx: 642.5,
    cy: 216.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye3",
    cx: 637.3,
    cy: 220.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftNose0",
    cx: 633.8,
    cy: 238.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftMouthCorner",
    cx: 641.7,
    cy: 260.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftNose1",
    cx: 629,
    cy: 238.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftUpperLipTop0",
    cx: 634.8,
    cy: 256.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftUpperLipTop1",
    cx: 628.4,
    cy: 255.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "leftMiddleLip",
    d: "M638.1,259.7c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8 C637.3,260.1,637.7,259.7,638.1,259.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftUpperLipBottom1",
    cx: 628.2,
    cy: 259.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftLowerLipTop0",
    cx: 628.2,
    cy: 262.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftLowerLipBottom1",
    cx: 628.4,
    cy: 269.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftLowerLipBottom0",
    cx: 635.3,
    cy: 266.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftEye4",
    cx: 642.5,
    cy: 221.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw7",
    cx: 639,
    cy: 292.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw6",
    cx: 649,
    cy: 286.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw5",
    cx: 660.6,
    cy: 273.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw4",
    cx: 667.4,
    cy: 253.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw3",
    cx: 668.2,
    cy: 231.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw2",
    cx: 668.2,
    cy: 222.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw1",
    cx: 667.4,
    cy: 210.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw0",
    cx: 664.9,
    cy: 201.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "624.2,174.9 604.4,177.4 591.9,186.9 583.3,201 580.8,210.3 580,222 580,231.5 580.8,253.2  587.6,273.2 599.2,285.7 609.2,292.4 624.2,295.6 639,292.8 649,286.1 660.6,273.5 667.4,253.5 668.2,231.9 668.2,222.3  667.4,210.6 664.9,201.4 656.7,186.9 644.1,177.4 624.2,174.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "588.2,211.8 592.2,208.1 598.4,207.1 605.7,207.1 615.5,211.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "594.4,220 599.6,216.3 605.9,216.3 611.1,220.5 605.9,221.5 599.6,222.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "612.7,238.1 617.9,238.1 623.4,238.9 623.4,233.6 623.4,226.5 623.4,221 623.4,215.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "659.7,211.4 655.7,208.5 649.4,207 642.1,207.4 632.1,210.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "653.8,220 648.5,216.3 642.2,216.3 637.1,220.5 642.2,221.5 648.5,222.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "633.8,238.1 628.8,238.1 623.4,238.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "606.7,260.2 613.6,256.8 620.1,255.7 624.2,256.6 628.4,255.7 634.8,256.8 641.7,260.2 635.3,266.5  628.2,269.3 624.2,269.8 620.1,269.3 613.1,266.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "606.7,260.2 610.3,260.5 620.3,259.7 624.2,260.2 628.2,259.7 638.1,260.5 641.7,260.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "606.7,260.2 610.3,260.5 620.3,262.6 624.2,263.4 628.2,262.6 638.1,260.5 641.7,260.2  "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightTop0",
    cx: 604.5,
    cy: 177.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rightTop1",
    cx: 591.9,
    cy: 186.9,
    r: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstract);
export default __webpack_public_path__ + "static/media/abstract.154a97dd24ac17dd22ccd13455084b37.svg";
export { ForwardRef as ReactComponent };